import {
    FETCH_PEER_CONFIG_REQUEST,
    FETCH_PEER_CONFIG_SUCCESS,
    FETCH_PEER_CONFIG_FAILURE,
    UPDATE_PEER_CONFIG_REQUEST,
    UPDATE_PEER_CONFIG_SUCCESS,
    UPDATE_PEER_CONFIG_FAILURE,
} from '../actions/peerEvaluationConfigActions';

const initialState = {
    config: null,
    loading: false,
    error: null,
};

const peerEvaluationConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PEER_CONFIG_REQUEST:
        case UPDATE_PEER_CONFIG_REQUEST:
            return { ...state, loading: true, error: null };
            
        case FETCH_PEER_CONFIG_SUCCESS:
        case UPDATE_PEER_CONFIG_SUCCESS:
            return { ...state, loading: false, config: action.payload, error: null };
            
        case FETCH_PEER_CONFIG_FAILURE:
        case UPDATE_PEER_CONFIG_FAILURE:
            return { ...state, loading: false, error: action.payload };
            
        default:
            return state;
    }
};

export default peerEvaluationConfigReducer;
